import { createRef, useState } from "react";

// @mui material components
import {
  Container, Grid, Link, Popper, Grow, Icon
} from "@mui/material";

import MKBox from "components/MKBox"
import MKButton from "components/MKButton"
import MKTypography from "components/MKTypography"

import { FaGithub, FaYoutube, FaLinkedin, FaBars  } from "react-icons/fa";

export default function Navbar() {
  const [dropdown, setDropdown] = useState(false);
  const [highlighted, setHighlighted] = useState("");
  const ref = createRef(null);

  return (
    <MKBox component="nav" position="absolute" top="2.5rem" width="100%">
      <Popper
        anchorEl={dropdown}
        popperRef={null}
        open={Boolean(dropdown)}
        placement="top-start"
        transition
        style={{ zIndex: 10 }}
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            sx={{
              transformOrigin: "left top",
              background: ({ palette: { white } }) => white.main,
            }}
          >
            <MKBox borderRadius="lg" onMouseLeave={() => {
              setDropdown(false); 
              setHighlighted("");
            }}>
              <MKTypography
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                variant="button"
                textTransform="capitalize"
                minWidth={"12rem"}
                color={"text"}
                fontWeight={"regular"}
                py={1}
                px={2}
                onClick={() => window.location.href = "/index"}
                sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                  borderRadius: borderRadius.md,
                  cursor: "pointer",
                  transition: "all 300ms linear",
    
                  "&:hover": {
                    backgroundColor: grey[200],
                    color: dark.main,
    
                    "& *": {
                      color: dark.main,
                    },
                  },
                })}
              >
                <MKBox>
                  <MKTypography
                    display="block"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                    sx={{ transition: "all 300ms linear" }}
                  >
                    {"Home"}
                  </MKTypography>
                </MKBox>
              </MKTypography>

              <MKTypography
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                variant="button"
                textTransform="capitalize"
                minWidth={"12rem"}
                color={"text"}
                fontWeight={"regular"}
                py={1}
                px={2}
                onClick={() => window.location.href = "/about-me"}
                sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                  borderRadius: borderRadius.md,
                  cursor: "pointer",
                  transition: "all 300ms linear",
    
                  "&:hover": {
                    backgroundColor: grey[200],
                    color: dark.main,
    
                    "& *": {
                      color: dark.main,
                    },
                  },
                })}
              >
                <MKBox>
                  <MKTypography
                    display="block"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                    sx={{ transition: "all 300ms linear" }}
                  >
                    {"Résumé"}
                  </MKTypography>
                </MKBox>
              </MKTypography>
              
              <MKTypography
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                variant="button"
                textTransform="capitalize"
                minWidth={"12rem"}
                color={"text"}
                fontWeight={"regular"}
                py={1}
                px={2}
                onClick={() => window.location.href = "/projects"}
                sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                  borderRadius: borderRadius.md,
                  cursor: "pointer",
                  transition: "all 300ms linear",
    
                  "&:hover": {
                    backgroundColor: grey[200],
                    color: dark.main,
    
                    "& *": {
                      color: dark.main,
                    },
                  },
                })}
              >
                <MKBox>
                  <MKTypography
                    display="block"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                    sx={{ transition: "all 300ms linear" }}
                  >
                    {"Projects"}
                  </MKTypography>
                </MKBox>
              </MKTypography>
              
            </MKBox>
          </Grow>
        )}
      </Popper>
      <Container>
        <Grid container flexDirection="row" alignItems="center">
          <MKTypography
            component={Link}
            href="/index"
            variant="button"
            color="white"
            fontFamily="Ubuntu"
            fontWeight="bold"
            fontSize={20}
            py={0.8125}
            mr={2}
          >
            Jackson Cagle
          </MKTypography>
          <MKButton
            variant="outlined"
            color="white"
            sx={{ display: { xs: "block", lg: "none" }, ml: "auto" }} onClick={(e) => setDropdown((target) => target ? null : e.currentTarget)}
          >
            <FaBars />
          </MKButton>
          <MKBox
            component="ul"
            display={{ xs: "none", lg: "flex" }}
            p={0}
            my={0}
            mx="auto"
            sx={{ listStyle: "none" }}
          >
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="/index"
                variant="button"
                color="white"
                fontSize={18}
                fontWeight="regular"
                px={2}
              >
                Home
              </MKTypography>
            </MKBox>
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="/about-me"
                variant="button"
                color="white"
                fontSize={18}
                fontWeight="regular"
                px={2}
              >
                Résumé
              </MKTypography>
            </MKBox>
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="/projects"
                variant="button"
                color="white"
                fontSize={18}
                fontWeight="regular"
                px={2}
              >
                Projects
              </MKTypography>
            </MKBox>
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="/posts"
                variant="button"
                color="white"
                fontSize={18}
                fontWeight="regular"
                px={2}
              >
                Blog Posts
              </MKTypography>
            </MKBox>
          </MKBox>
          <MKBox
            component="ul"
            display={{ xs: "none", lg: "flex" }}
            p={0}
            m={0}
            sx={{
              listStyle: "none",
              backgroundColor: "rgba(128,128,128,0.8)",
              backdropFilter: "blur(2px)",
              borderRadius: "8px",
              px: 1,
            }}
          >
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="https://github.com/JCagle95"
                target="_blank"
                variant="button"
                p={1}
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <FaGithub fontSize={24} color="#181717" />
              </MKTypography>
            </MKBox>
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="https://www.linkedin.com/in/jackson-cagle-44819091/"
                target="_blank"
                variant="button"
                p={1}
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <FaLinkedin fontSize={24} color="#0A66C2" />
              </MKTypography>
            </MKBox>
            <MKBox component="li">
              <MKTypography
                component={Link}
                href="https://www.youtube.com/@jacksoncagle3114"
                target="_blank"
                variant="button"
                p={1}
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <FaYoutube fontSize={24} color="#a13636ff " />
              </MKTypography>
            </MKBox>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  )

}